import React from "react";
import { fetchDataFile } from "./Fetch";


class ContentLoader extends React.Component {
    constructor(props) {
      super(props);

      this.onLoadComplete = this.onLoadComplete.bind(this);
    }

    componentDidMount() {
        if (this.props.id)
        fetchDataFile(this.props.id, this.props.url, this.onLoadComplete);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.lang !== this.props.lang && this.props.id)
        fetchDataFile(this.props.id, this.props.url, this.onLoadComplete);
    }    

    onLoadComplete(data) {
        this.props.onComplete(data);
      }

    render() {
        return <div>
            {this.props.children}
        </div>
    }
}

export default ContentLoader;